<div
	class="modal fade"
	id="filtersModal"
	tabindex="-1"
	role="dialog"
	aria-labelledby="filtersModalLabel"
	aria-hidden="true"
>
	<div class="modal-dialog modal-dialog-scrollable">
		<div class="modal-content">
			<div class="modal-body">
				<div class="container">
					<div class="mb-3">
						<!-- {{ products | json }} -->
						<label for="products" class="mt-3">Produkty</label>
						<ng-select
							id="products"
							name="products"
							[(ngModel)]="filters.products"
							[multiple]="true"
							[closeOnSelect]="false"
						>
							<ng-option *ngFor="let item of products" [value]="item.id">{{ item.name }}</ng-option>
						</ng-select>
					</div>

					<div class="form-floating mb-3">
						<select class="form-select" id="isActive" name="isActive" [(ngModel)]="filters.is_active">
							<option value="">(wszystkie)</option>
							<option [value]="item.value" *ngFor="let item of yesno">
								{{ item.name }}
							</option>
						</select>
						<label for="isActive">Aktywne</label>
					</div>
					<div class="mb-3">
						<div class="row g-2">
							<div class="form-floating col-md">
								<input
									type="date"
									class="form-control"
									name="filters.date_sell_from"
									[(ngModel)]="filters.promotion_sells[0]"
									id="filters.date_sell_from"
								/>
								<label for="filters.date_sell_from" class="form-label">Okres sprzedaży od</label>
							</div>
							<div class="form-floating col-md">
								<input
									type="date"
									class="form-control"
									name="filters.date_sell_to"
									[(ngModel)]="filters.promotion_sells[1]"
									id="filters.date_sell_to"
								/>
								<label for="filters.date_sell_to" class="form-label">Okres sprzedaży do</label>
							</div>
						</div>
					</div>
					<div class="mb-3">
						<div class="row g-2">
							<div class="form-floating col-md">
								<input
									type="date"
									class="form-control"
									name="filters.date_offer_from"
									[(ngModel)]="filters.promotion_offers[0]"
									id="filters.date_from"
								/>
								<label for="filters.date_offer_from" class="form-label">Okres ofert od</label>
							</div>
							<div class="form-floating col-md">
								<input
									type="date"
									class="form-control"
									name="filters.date_offer_to"
									[(ngModel)]="filters.promotion_offers[1]"
									id="filters.date_offer_to"
								/>
								<label for="filters.date_offer_to" class="form-label">Okres ofert do</label>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="modal-footer">
				<div class="row row-full">
					<div class="row">
						<div class="col-sm-7 text-start">
							<button type="button" class="btn btn-danger me-1" (click)="filtersClear()">Wyczyść</button>
							<button type="button" class="btn btn-success" (click)="filtersDefault()">Domyślne</button>
						</div>
						<div class="col-sm-5 text-end">
							<button type="button" class="btn btn-primary me-1" (click)="filtersSave()">Pokaż</button>
							<button
								type="button"
								class="btn btn-secondary"
								(click)="filtersClose()"
								data-bs-dismiss="modal"
							>
								Anuluj
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
